import { concat, map } from 'es-toolkit/compat';
import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { TurnTimeUpdateRequest } = protos;

/**
 * Fetches globally configured turn times.
 * These are not suitable for use in service for businesses using scheduled inventory,
 * use fetchForServiceDay instead.
 * @returns {Object} A redux TockApi action.
 */
export function fetchAll(): ApiAction {
  return {
    TockApi: {
      getListProto: '/business/config/turntimes',
      type: AppConstants.TURN_TIMES_FETCH_ALL,
    },
  };
}

/**
 * Fetches all turn times for the specified service date.
 * @returns {Object} A redux TockApi action.
 */
export function fetchForServiceDay(date: string): ApiAction {
  return {
    TockApi: {
      getListProto: `/business/config/turntimes/day?date=${date}`,
      type: AppConstants.TURN_TIMES_FETCH_FOR_SERVICE_DAY,
    },
  };
}

/**
 * Tells the server to create or update turn times to match the given specifications.
 * If a turn time with the relevant sizes, template, experience, etc exists on the
 * server, its expected turn time will be updated; otherwise a turn time with the
 * specified properties will be created with the given expected turn time.
 *
 * @param turnTimes an array of turn times to update or create
 * @param turnTimeIdsToRemove an array of ids for turn times that should be removed
 * @returns {Object} A redux TockApi action.
 */
export function update(
  turnTimes: Array<Partial<dashboard.TurnTime>>,
  turnTimeIdsToRemove?: number[]
): ApiAction {
  const upserts: dashboard.TurnTimeUpdateRequest.Update[] = map(turnTimes, (tt) => {
    return {
      upsert: {
        turnTime: tt,
      },
    };
  });
  const removes: dashboard.TurnTimeUpdateRequest.Update[] = map(turnTimeIdsToRemove, (ttid) => {
    return {
      remove: {
        id: ttid,
      },
    };
  });
  const turnTimeUpdateRequest = TurnTimeUpdateRequest.fromObject({
    update: concat(upserts, removes),
  });
  return {
    TockApi: {
      postProto: '/business/config/turntimes',
      type: AppConstants.TURN_TIMES_UPDATE,
      request: turnTimeUpdateRequest,
    },
  };
}

export function replaceAll(newTurnTime: Array<Partial<dashboard.TurnTime>>) {
  return {
    TockApi: {
      postProto: '/business/config/turntimes',
      type: AppConstants.TURN_TIMES_REPLACE_ALL,
      request: TurnTimeUpdateRequest.fromObject({
        replace: {
          newTurnTime,
        },
      }),
    },
  };
}
